import { render } from "./ErrorSummary.vue?vue&type=template&id=04ca17a8&ts=true"
import script from "./ErrorSummary.vue?vue&type=script&lang=ts"
export * from "./ErrorSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__